import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import CaretLeft from '../icons/CaretLeft';
import CaretRight from '../icons/CaretRight';
import { MonthHeader, MonthNavButton, MonthTitle, DaysOfWeekRow, DayCell } from '../DateRangeTimePicker.styles';

const DateRangeTimePickerMonthNavigation = ({ currentMonth, currentYear, onPrevMonth, onNextMonth }) => {
  const monthName = format(new Date(currentYear, currentMonth), 'MMMM');

  return (
    <>
      <MonthHeader>
        <MonthNavButton onClick={onPrevMonth}>
          <CaretLeft />
        </MonthNavButton>
        <MonthTitle>
          {monthName} {currentYear}
        </MonthTitle>
        <MonthNavButton onClick={onNextMonth}>
          <CaretRight />
        </MonthNavButton>
      </MonthHeader>
      <DaysOfWeekRow>
        <DayCell as="div">Su</DayCell>
        <DayCell as="div">Mo</DayCell>
        <DayCell as="div">Tu</DayCell>
        <DayCell as="div">We</DayCell>
        <DayCell as="div">Th</DayCell>
        <DayCell as="div">Fr</DayCell>
        <DayCell as="div">Sa</DayCell>
      </DaysOfWeekRow>
    </>
  );
};

DateRangeTimePickerMonthNavigation.propTypes = {
  currentMonth: PropTypes.number.isRequired,
  currentYear: PropTypes.number.isRequired,
  onPrevMonth: PropTypes.func.isRequired,
  onNextMonth: PropTypes.func.isRequired,
};

export default DateRangeTimePickerMonthNavigation;
